import { paths } from 'src/routes/paths';

import { ICONS } from 'src/utils/icons';
import { roles } from 'src/utils/roles';


// ----------------------------------------------------------------------


export const navData = [
  /**
   * Overview
   */
  {
    subheader: 'Overview',
    items: [
      { title: 'Home', path: paths.root, icon: ICONS.app },
      { title: 'Insights', path: paths.chat, icon: ICONS.chat, feature: 'chat', roles: [roles.AI] },
    ],
  },
  /**
   * Reporting
   */
  {
    subheader: 'Reporting',
    items: [
      {
        title: 'Reports',
        roles: [roles.VIEW_REPORTS],
        path: paths.reports.root,
        icon: ICONS.reports,
        children: [
          { title: 'Report List', path: paths.reports.list, icon: ICONS.list },
          { title: 'Report Schedules', path: paths.reports.schedules, icon: ICONS.schedule },
          // The envysion* features already check the user's Envysion roles (backend
          // apps/envysion/access.py); the menu also needs Reports' ROLE_VIEW_REPORTS
          { title: 'Envysion Report', path: paths.envysion.cameraView, icon: ICONS.camera, feature: 'envysionCameraView' },
          { title: 'Envysion PH Ticket View', path: paths.envysion.ticketViewPh, icon: ICONS.document, feature: 'envysionTicketViewPh' },
          { title: 'Envysion TB Ticket View', path: paths.envysion.ticketViewTb, icon: ICONS.document, feature: 'envysionTicketViewTb' },
        ],
      },
      {
        title: 'In-Store Reports',
        roles: [roles.VIEW_REPORTS],
        path: paths.inStoreReports.root,
        icon: ICONS.inStore,
        children: [
          { title: 'In-Store Report List', path: paths.inStoreReports.list, icon: ICONS.list },
          { title: 'In-Store Report Schedules', path: paths.inStoreReports.schedules.list, icon: ICONS.schedule },
        ],
      },
      {
        title: 'Report Builder',
        roles: [roles.ADHOC],
        feature: 'reportBuilder',
        path: paths.reportBuilder.list,
        icon: ICONS.analytics,
      },
    ],
  },
  /**
   * Paycard
   */
  {
    subheader: 'Paycard',
    items: [
      { title: 'Rapid Cards', roles: [roles.PAYCARD_RAPID_ADMIN], path: paths.paycard.rapidCards, icon: ICONS.course },
      { title: 'Config', roles: [roles.ADMIN], path: paths.paycard.config, icon: ICONS.course },
      { title: 'Rapid Config', roles: [roles.ADMIN], path: paths.paycard.rapidConfig, icon: ICONS.course },
      { title: 'Rapid Disbursement Config', roles: [roles.ADMIN], path: paths.paycard.rapidDisbursementConfig, icon: ICONS.course },
      { title: 'Akimbo Distributor Map', roles: [roles.ADMIN], path: paths.paycard.akimboDistributorMap, icon: ICONS.course },
      { title: 'Payments', roles: [roles.PAYCARD_ADMIN], path: paths.paycard.payments, icon: ICONS.course },
      { title: 'Employees', roles: [roles.PAYCARD_ADMIN], path: paths.paycard.employees.list, icon: ICONS.course },
    ],
  },
  /**
   * Above Store
   */
  {
    subheader: 'Above Store',
    items: [
      {
        title: 'Accounting',
        roles: [roles.ADMIN, roles.AMOUNTS_EDITOR],
        feature: 'amountsEditor',
        path: paths.aboveStore.root,
        icon: ICONS.banking,
        children: [
          {
            title: 'Amounts Editor',
            path: paths.aboveStore.acct.amounts.setup,
            icon: ICONS.list,
            roles: [roles.ADMIN, roles.AMOUNTS_EDITOR],
            feature: 'amountsEditor',
          },
        ],
      },
    ],
  },
  /**
   * Management
   */
  {
    subheader: 'Management',
    items: [
      { title: 'Users', roles: [roles.USER_ADMIN], path: paths.management.user.root, icon: ICONS.user },
      { title: 'Stores', roles: [roles.STORE_ADMIN], path: paths.management.store.root, icon: ICONS.store },
      { title: 'Coupons', roles: [roles.STORE_ADMIN], path: paths.management.coupon.root, icon: ICONS.coupon },
    ],
  },
  /**
   * Item State
   */
  {
    subheader: 'Misc',
    items: [
      {
        // default roles : All roles can see this entry.
        // roles: ['user'] Only users can see this item.
        // roles: ['admin'] Only admin can see this item.
        // roles: ['admin', 'manager'] Only admin/manager can see this item.
        // Reference from 'src/guards/RoleBasedGuard'.
        title: 'Alignment Assignment',
        path: paths.misc.alignmentAssignment,
        icon: ICONS.assignment,
        roles: [roles.ORG_ADMIN],
      },
    ],
  },
];
